@if (!cellRenderer) {
  @if (value || value === 0) {
    {{ value }}
  }
  @else {
    <span class="text-slate-300">-</span>
  }
}
